import { render, staticRenderFns } from "./ReminderForm.vue?vue&type=template&id=d2a449e2"
import script from "./ReminderForm.vue?vue&type=script&lang=ts"
export * from "./ReminderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports